export default [
  {
    value: 'FR',
    name: 'France',
    id: 'FranceFirst',
    inEuropeanUnion: true
  },
  {
    value: 'AF',
    name: 'Afghanistan',
    id: 'Afghanistan',
    inEuropeanUnion: false
  },
  {
    value: 'AX',
    name: 'Åland Islands',
    id: 'Åland Islands',
    inEuropeanUnion: false
  },
  {
    value: 'AL',
    name: 'Albania',
    id: 'Albania',
    inEuropeanUnion: false
  },
  {
    value: 'DZ',
    name: 'Algeria',
    id: 'Algeria',
    inEuropeanUnion: false
  },
  {
    value: 'AS',
    name: 'American Samoa',
    id: 'American Samoa',
    inEuropeanUnion: false
  },
  {
    value: 'AD',
    name: 'Andorra',
    id: 'Andorra',
    inEuropeanUnion: false
  },
  {
    value: 'AO',
    name: 'Angola',
    id: 'Angola',
    inEuropeanUnion: false
  },
  {
    value: 'AI',
    name: 'Anguilla',
    id: 'Anguilla',
    inEuropeanUnion: false
  },
  {
    value: 'AQ',
    name: 'Antarctica',
    id: 'Antarctica',
    inEuropeanUnion: false
  },
  {
    value: 'AG',
    name: 'Antigua and Barbuda',
    id: 'Antigua and Barbuda',
    inEuropeanUnion: false
  },
  {
    value: 'AR',
    name: 'Argentina',
    id: 'Argentina',
    inEuropeanUnion: false
  },
  {
    value: 'AM',
    name: 'Armenia',
    id: 'Armenia',
    inEuropeanUnion: false
  },
  {
    value: 'AW',
    name: 'Aruba',
    id: 'Aruba',
    inEuropeanUnion: false
  },
  {
    value: 'AU',
    name: 'Australia',
    id: 'Australia',
    inEuropeanUnion: false
  },
  {
    value: 'AT',
    name: 'Austria',
    id: 'Austria',
    inEuropeanUnion: true
  },
  {
    value: 'AZ',
    name: 'Azerbaijan',
    id: 'Azerbaijan',
    inEuropeanUnion: false
  },
  {
    value: 'BS',
    name: 'Bahamas',
    id: 'Bahamas',
    inEuropeanUnion: false
  },
  {
    value: 'BH',
    name: 'Bahrain',
    id: 'Bahrain',
    inEuropeanUnion: false
  },
  {
    value: 'BD',
    name: 'Bangladesh',
    id: 'Bangladesh',
    inEuropeanUnion: false
  },
  {
    value: 'BB',
    name: 'Barbados',
    id: 'Barbados',
    inEuropeanUnion: false
  },
  {
    value: 'BY',
    name: 'Belarus',
    id: 'Belarus',
    inEuropeanUnion: false
  },
  {
    value: 'BE',
    name: 'Belgium',
    id: 'Belgium',
    inEuropeanUnion: true
  },
  {
    value: 'BZ',
    name: 'Belize',
    id: 'Belize',
    inEuropeanUnion: false
  },
  {
    value: 'BJ',
    name: 'Benin',
    id: 'Benin',
    inEuropeanUnion: false
  },
  {
    value: 'BM',
    name: 'Bermuda',
    id: 'Bermuda',
    inEuropeanUnion: false
  },
  {
    value: 'BT',
    name: 'Bhutan',
    id: 'Bhutan',
    inEuropeanUnion: false
  },
  {
    value: 'BO',
    name: 'Bolivia, Plurinational State of',
    id: 'Bolivia, Plurinational State of',
    inEuropeanUnion: false
  },
  {
    value: 'BQ',
    name: 'Bonaire, Sint Eustatius and Saba',
    id: 'Bonaire, Sint Eustatius and Saba',
    inEuropeanUnion: false
  },
  {
    value: 'BA',
    name: 'Bosnia and Herzegovina',
    id: 'Bosnia and Herzegovina',
    inEuropeanUnion: false
  },
  {
    value: 'BW',
    name: 'Botswana',
    id: 'Botswana',
    inEuropeanUnion: false
  },
  {
    value: 'BV',
    name: 'Bouvet Island',
    id: 'Bouvet Island',
    inEuropeanUnion: false
  },
  {
    value: 'BR',
    name: 'Brazil',
    id: 'Brazil',
    inEuropeanUnion: false
  },
  {
    value: 'IO',
    name: 'British Indian Ocean Territory',
    id: 'British Indian Ocean Territory',
    inEuropeanUnion: false
  },
  {
    value: 'BN',
    name: 'Brunei Darussalam',
    id: 'Brunei Darussalam',
    inEuropeanUnion: false
  },
  {
    value: 'BG',
    name: 'Bulgaria',
    id: 'Bulgaria',
    inEuropeanUnion: true
  },
  {
    value: 'BF',
    name: 'Burkina Faso',
    id: 'Burkina Faso',
    inEuropeanUnion: false
  },
  {
    value: 'BI',
    name: 'Burundi',
    id: 'Burundi',
    inEuropeanUnion: false
  },
  {
    value: 'KH',
    name: 'Cambodia',
    id: 'Cambodia',
    inEuropeanUnion: false
  },
  {
    value: 'CM',
    name: 'Cameroon',
    id: 'Cameroon',
    inEuropeanUnion: false
  },
  {
    value: 'CA',
    name: 'Canada',
    id: 'Canada',
    inEuropeanUnion: false
  },
  {
    value: 'CV',
    name: 'Cape Verde',
    id: 'Cape Verde',
    inEuropeanUnion: false
  },
  {
    value: 'KY',
    name: 'Cayman Islands',
    id: 'Cayman Islands',
    inEuropeanUnion: false
  },
  {
    value: 'CF',
    name: 'Central African Republic',
    id: 'Central African Republic',
    inEuropeanUnion: false
  },
  {
    value: 'TD',
    name: 'Chad',
    id: 'Chad',
    inEuropeanUnion: false
  },
  {
    value: 'CL',
    name: 'Chile',
    id: 'Chile',
    inEuropeanUnion: false
  },
  {
    value: 'CN',
    name: 'China',
    id: 'China',
    inEuropeanUnion: false
  },
  {
    value: 'CX',
    name: 'Christmas Island',
    id: 'Christmas Island',
    inEuropeanUnion: false
  },
  {
    value: 'CC',
    name: 'Cocos (Keeling) Islands',
    id: 'Cocos (Keeling) Islands',
    inEuropeanUnion: false
  },
  {
    value: 'CO',
    name: 'Colombia',
    id: 'Colombia',
    inEuropeanUnion: false
  },
  {
    value: 'KM',
    name: 'Comoros',
    id: 'Comoros',
    inEuropeanUnion: false
  },
  {
    value: 'CG',
    name: 'Congo',
    id: 'Congo',
    inEuropeanUnion: false
  },
  {
    value: 'CD',
    name: 'Congo, the Democratic Republic of the',
    id: 'Congo, the Democratic Republic of the',
    inEuropeanUnion: false
  },
  {
    value: 'CK',
    name: 'Cook Islands',
    id: 'Cook Islands',
    inEuropeanUnion: false
  },
  {
    value: 'CR',
    name: 'Costa Rica',
    id: 'Costa Rica',
    inEuropeanUnion: false
  },
  {
    value: 'CI',
    name: "Côte d'Ivoire",
    id: "Côte d'Ivoire",
    inEuropeanUnion: false
  },
  {
    value: 'HR',
    name: 'Croatia',
    id: 'Croatia',
    inEuropeanUnion: true
  },
  {
    value: 'CU',
    name: 'Cuba',
    id: 'Cuba',
    inEuropeanUnion: false
  },
  {
    value: 'CW',
    name: 'Curaçao',
    id: 'Curaçao',
    inEuropeanUnion: false
  },
  {
    value: 'CY',
    name: 'Cyprus',
    id: 'Cyprus',
    inEuropeanUnion: true
  },
  {
    value: 'CZ',
    name: 'Czech Republic',
    id: 'Czech Republic',
    inEuropeanUnion: true
  },
  {
    value: 'DK',
    name: 'Denmark',
    id: 'Denmark',
    inEuropeanUnion: true
  },
  {
    value: 'DJ',
    name: 'Djibouti',
    id: 'Djibouti',
    inEuropeanUnion: false
  },
  {
    value: 'DM',
    name: 'Dominica',
    id: 'Dominica',
    inEuropeanUnion: false
  },
  {
    value: 'DO',
    name: 'Dominican Republic',
    id: 'Dominican Republic',
    inEuropeanUnion: false
  },
  {
    value: 'EC',
    name: 'Ecuador',
    id: 'Ecuador',
    inEuropeanUnion: false
  },
  {
    value: 'EG',
    name: 'Egypt',
    id: 'Egypt',
    inEuropeanUnion: false
  },
  {
    value: 'SV',
    name: 'El Salvador',
    id: 'El Salvador',
    inEuropeanUnion: false
  },
  {
    value: 'GQ',
    name: 'Equatorial Guinea',
    id: 'Equatorial Guinea',
    inEuropeanUnion: false
  },
  {
    value: 'ER',
    name: 'Eritrea',
    id: 'Eritrea',
    inEuropeanUnion: false
  },
  {
    value: 'EE',
    name: 'Estonia',
    id: 'Estonia',
    inEuropeanUnion: true
  },
  {
    value: 'ET',
    name: 'Ethiopia',
    id: 'Ethiopia',
    inEuropeanUnion: false
  },
  {
    value: 'FK',
    name: 'Falkland Islands (Malvinas)',
    id: 'Falkland Islands (Malvinas)',
    inEuropeanUnion: false
  },
  {
    value: 'FO',
    name: 'Faroe Islands',
    id: 'Faroe Islands',
    inEuropeanUnion: false
  },
  {
    value: 'FJ',
    name: 'Fiji',
    id: 'Fiji',
    inEuropeanUnion: false
  },
  {
    value: 'FI',
    name: 'Finland',
    id: 'Finland',
    inEuropeanUnion: true
  },
  {
    value: 'FR',
    name: 'France',
    id: 'France',
    inEuropeanUnion: true
  },
  {
    value: 'GF',
    name: 'French Guiana',
    id: 'French Guiana',
    inEuropeanUnion: false
  },
  {
    value: 'PF',
    name: 'French Polynesia',
    id: 'French Polynesia',
    inEuropeanUnion: false
  },
  {
    value: 'TF',
    name: 'French Southern Territories',
    id: 'French Southern Territories',
    inEuropeanUnion: false
  },
  {
    value: 'GA',
    name: 'Gabon',
    id: 'Gabon',
    inEuropeanUnion: false
  },
  {
    value: 'GM',
    name: 'Gambia',
    id: 'Gambia',
    inEuropeanUnion: false
  },
  {
    value: 'GE',
    name: 'Georgia',
    id: 'Georgia',
    inEuropeanUnion: false
  },
  {
    value: 'DE',
    name: 'Germany',
    id: 'Germany',
    inEuropeanUnion: true
  },
  {
    value: 'GH',
    name: 'Ghana',
    id: 'Ghana',
    inEuropeanUnion: false
  },
  {
    value: 'GI',
    name: 'Gibraltar',
    id: 'Gibraltar',
    inEuropeanUnion: false
  },
  {
    value: 'GR',
    name: 'Greece',
    id: 'Greece',
    inEuropeanUnion: true
  },
  {
    value: 'GL',
    name: 'Greenland',
    id: 'Greenland',
    inEuropeanUnion: false
  },
  {
    value: 'GD',
    name: 'Grenada',
    id: 'Grenada',
    inEuropeanUnion: false
  },
  {
    value: 'GP',
    name: 'Guadeloupe',
    id: 'Guadeloupe',
    inEuropeanUnion: false
  },
  {
    value: 'GU',
    name: 'Guam',
    id: 'Guam',
    inEuropeanUnion: false
  },
  {
    value: 'GT',
    name: 'Guatemala',
    id: 'Guatemala',
    inEuropeanUnion: false
  },
  {
    value: 'GG',
    name: 'Guernsey',
    id: 'Guernsey',
    inEuropeanUnion: false
  },
  {
    value: 'GN',
    name: 'Guinea',
    id: 'Guinea',
    inEuropeanUnion: false
  },
  {
    value: 'GW',
    name: 'Guinea-Bissau',
    id: 'Guinea-Bissau',
    inEuropeanUnion: false
  },
  {
    value: 'GY',
    name: 'Guyana',
    id: 'Guyana',
    inEuropeanUnion: false
  },
  {
    value: 'HT',
    name: 'Haiti',
    id: 'Haiti',
    inEuropeanUnion: false
  },
  {
    value: 'HM',
    name: 'Heard Island and McDonald Islands',
    id: 'Heard Island and McDonald Islands',
    inEuropeanUnion: false
  },
  {
    value: 'VA',
    name: 'Holy See (Vatican City State)',
    id: 'Holy See (Vatican City State)',
    inEuropeanUnion: false
  },
  {
    value: 'HN',
    name: 'Honduras',
    id: 'Honduras',
    inEuropeanUnion: false
  },
  {
    value: 'HK',
    name: 'Hong Kong',
    id: 'Hong Kong',
    inEuropeanUnion: false
  },
  {
    value: 'HU',
    name: 'Hungary',
    id: 'Hungary',
    inEuropeanUnion: true
  },
  {
    value: 'IS',
    name: 'Iceland',
    id: 'Iceland',
    inEuropeanUnion: false
  },
  {
    value: 'IN',
    name: 'India',
    id: 'India',
    inEuropeanUnion: false
  },
  {
    value: 'ID',
    name: 'Indonesia',
    id: 'Indonesia',
    inEuropeanUnion: false
  },
  {
    value: 'IR',
    name: 'Iran, Islamic Republic of',
    id: 'Iran, Islamic Republic of',
    inEuropeanUnion: false
  },
  {
    value: 'IQ',
    name: 'Iraq',
    id: 'Iraq',
    inEuropeanUnion: false
  },
  {
    value: 'IE',
    name: 'Ireland',
    id: 'Ireland',
    inEuropeanUnion: true
  },
  {
    value: 'IM',
    name: 'Isle of Man',
    id: 'Isle of Man',
    inEuropeanUnion: false
  },
  {
    value: 'IL',
    name: 'Israel',
    id: 'Israel',
    inEuropeanUnion: false
  },
  {
    value: 'IT',
    name: 'Italy',
    id: 'Italy',
    inEuropeanUnion: true
  },
  {
    value: 'JM',
    name: 'Jamaica',
    id: 'Jamaica',
    inEuropeanUnion: false
  },
  {
    value: 'JP',
    name: 'Japan',
    id: 'Japan',
    inEuropeanUnion: false
  },
  {
    value: 'JE',
    name: 'Jersey',
    id: 'Jersey',
    inEuropeanUnion: false
  },
  {
    value: 'JO',
    name: 'Jordan',
    id: 'Jordan',
    inEuropeanUnion: false
  },
  {
    value: 'KZ',
    name: 'Kazakhstan',
    id: 'Kazakhstan',
    inEuropeanUnion: false
  },
  {
    value: 'KE',
    name: 'Kenya',
    id: 'Kenya',
    inEuropeanUnion: false
  },
  {
    value: 'KI',
    name: 'Kiribati',
    id: 'Kiribati',
    inEuropeanUnion: false
  },
  {
    value: 'KP',
    name: "Korea, Democratic People's Republic of",
    id: "Korea, Democratic People's Republic of",
    inEuropeanUnion: false
  },
  {
    value: 'KR',
    name: 'Korea, Republic of',
    id: 'Korea, Republic of',
    inEuropeanUnion: false
  },
  {
    value: 'KW',
    name: 'Kuwait',
    id: 'Kuwait',
    inEuropeanUnion: false
  },
  {
    value: 'KG',
    name: 'Kyrgyzstan',
    id: 'Kyrgyzstan',
    inEuropeanUnion: false
  },
  {
    value: 'LA',
    name: "Lao People's Democratic Republic",
    id: "Lao People's Democratic Republic",
    inEuropeanUnion: false
  },
  {
    value: 'LV',
    name: 'Latvia',
    id: 'Latvia',
    inEuropeanUnion: true
  },
  {
    value: 'LB',
    name: 'Lebanon',
    id: 'Lebanon',
    inEuropeanUnion: false
  },
  {
    value: 'LS',
    name: 'Lesotho',
    id: 'Lesotho',
    inEuropeanUnion: false
  },
  {
    value: 'LR',
    name: 'Liberia',
    id: 'Liberia',
    inEuropeanUnion: false
  },
  {
    value: 'LY',
    name: 'Libya',
    id: 'Libya',
    inEuropeanUnion: false
  },
  {
    value: 'LI',
    name: 'Liechtenstein',
    id: 'Liechtenstein',
    inEuropeanUnion: false
  },
  {
    value: 'LT',
    name: 'Lithuania',
    id: 'Lithuania',
    inEuropeanUnion: true
  },
  {
    value: 'LU',
    name: 'Luxembourg',
    id: 'Luxembourg',
    inEuropeanUnion: true
  },
  {
    value: 'MO',
    name: 'Macao',
    id: 'Macao',
    inEuropeanUnion: false
  },
  {
    value: 'MK',
    name: 'Macedonia, the Former Yugoslav Republic of',
    id: 'Macedonia, the Former Yugoslav Republic of',
    inEuropeanUnion: false
  },
  {
    value: 'MG',
    name: 'Madagascar',
    id: 'Madagascar',
    inEuropeanUnion: false
  },
  {
    value: 'MW',
    name: 'Malawi',
    id: 'Malawi',
    inEuropeanUnion: false
  },
  {
    value: 'MY',
    name: 'Malaysia',
    id: 'Malaysia',
    inEuropeanUnion: false
  },
  {
    value: 'MV',
    name: 'Maldives',
    id: 'Maldives',
    inEuropeanUnion: false
  },
  {
    value: 'ML',
    name: 'Mali',
    id: 'Mali',
    inEuropeanUnion: false
  },
  {
    value: 'MT',
    name: 'Malta',
    id: 'Malta',
    inEuropeanUnion: true
  },
  {
    value: 'MH',
    name: 'Marshall Islands',
    id: 'Marshall Islands',
    inEuropeanUnion: false
  },
  {
    value: 'MQ',
    name: 'Martinique',
    id: 'Martinique',
    inEuropeanUnion: false
  },
  {
    value: 'MR',
    name: 'Mauritania',
    id: 'Mauritania',
    inEuropeanUnion: false
  },
  {
    value: 'MU',
    name: 'Mauritius',
    id: 'Mauritius',
    inEuropeanUnion: false
  },
  {
    value: 'YT',
    name: 'Mayotte',
    id: 'Mayotte',
    inEuropeanUnion: false
  },
  {
    value: 'MX',
    name: 'Mexico',
    id: 'Mexico',
    inEuropeanUnion: false
  },
  {
    value: 'FM',
    name: 'Micronesia, Federated States of',
    id: 'Micronesia, Federated States of',
    inEuropeanUnion: false
  },
  {
    value: 'MD',
    name: 'Moldova, Republic of',
    id: 'Moldova, Republic of',
    inEuropeanUnion: false
  },
  {
    value: 'MC',
    name: 'Monaco',
    id: 'Monaco',
    inEuropeanUnion: false
  },
  {
    value: 'MN',
    name: 'Mongolia',
    id: 'Mongolia',
    inEuropeanUnion: false
  },
  {
    value: 'ME',
    name: 'Montenegro',
    id: 'Montenegro',
    inEuropeanUnion: false
  },
  {
    value: 'MS',
    name: 'Montserrat',
    id: 'Montserrat',
    inEuropeanUnion: false
  },
  {
    value: 'MA',
    name: 'Morocco',
    id: 'Morocco',
    inEuropeanUnion: false
  },
  {
    value: 'MZ',
    name: 'Mozambique',
    id: 'Mozambique',
    inEuropeanUnion: false
  },
  {
    value: 'MM',
    name: 'Myanmar',
    id: 'Myanmar',
    inEuropeanUnion: false
  },
  {
    value: 'NA',
    name: 'Namibia',
    id: 'Namibia',
    inEuropeanUnion: false
  },
  {
    value: 'NR',
    name: 'Nauru',
    id: 'Nauru',
    inEuropeanUnion: false
  },
  {
    value: 'NP',
    name: 'Nepal',
    id: 'Nepal',
    inEuropeanUnion: false
  },
  {
    value: 'NL',
    name: 'Netherlands',
    id: 'Netherlands',
    inEuropeanUnion: true
  },
  {
    value: 'NC',
    name: 'New Caledonia',
    id: 'New Caledonia',
    inEuropeanUnion: false
  },
  {
    value: 'NZ',
    name: 'New Zealand',
    id: 'New Zealand',
    inEuropeanUnion: false
  },
  {
    value: 'NI',
    name: 'Nicaragua',
    id: 'Nicaragua',
    inEuropeanUnion: false
  },
  {
    value: 'NE',
    name: 'Niger',
    id: 'Niger',
    inEuropeanUnion: false
  },
  {
    value: 'NG',
    name: 'Nigeria',
    id: 'Nigeria',
    inEuropeanUnion: false
  },
  {
    value: 'NU',
    name: 'Niue',
    id: 'Niue',
    inEuropeanUnion: false
  },
  {
    value: 'NF',
    name: 'Norfolk Island',
    id: 'Norfolk Island',
    inEuropeanUnion: false
  },
  {
    value: 'MP',
    name: 'Northern Mariana Islands',
    id: 'Northern Mariana Islands',
    inEuropeanUnion: false
  },
  {
    value: 'NO',
    name: 'Norway',
    id: 'Norway',
    inEuropeanUnion: false
  },
  {
    value: 'OM',
    name: 'Oman',
    id: 'Oman',
    inEuropeanUnion: false
  },
  {
    value: 'PK',
    name: 'Pakistan',
    id: 'Pakistan',
    inEuropeanUnion: false
  },
  {
    value: 'PW',
    name: 'Palau',
    id: 'Palau',
    inEuropeanUnion: false
  },
  {
    value: 'PS',
    name: 'Palestine, State of',
    id: 'Palestine, State of',
    inEuropeanUnion: false
  },
  {
    value: 'PA',
    name: 'Panama',
    id: 'Panama',
    inEuropeanUnion: false
  },
  {
    value: 'PG',
    name: 'Papua New Guinea',
    id: 'Papua New Guinea',
    inEuropeanUnion: false
  },
  {
    value: 'PY',
    name: 'Paraguay',
    id: 'Paraguay',
    inEuropeanUnion: false
  },
  {
    value: 'PE',
    name: 'Peru',
    id: 'Peru',
    inEuropeanUnion: false
  },
  {
    value: 'PH',
    name: 'Philippines',
    id: 'Philippines',
    inEuropeanUnion: false
  },
  {
    value: 'PN',
    name: 'Pitcairn',
    id: 'Pitcairn',
    inEuropeanUnion: false
  },
  {
    value: 'PL',
    name: 'Poland',
    id: 'Poland',
    inEuropeanUnion: true
  },
  {
    value: 'PT',
    name: 'Portugal',
    id: 'Portugal',
    inEuropeanUnion: true
  },
  {
    value: 'PR',
    name: 'Puerto Rico',
    id: 'Puerto Rico',
    inEuropeanUnion: false
  },
  {
    value: 'QA',
    name: 'Qatar',
    id: 'Qatar',
    inEuropeanUnion: false
  },
  {
    value: 'RE',
    name: 'Réunion',
    id: 'Réunion',
    inEuropeanUnion: false
  },
  {
    value: 'RO',
    name: 'Romania',
    id: 'Romania',
    inEuropeanUnion: true
  },
  {
    value: 'RU',
    name: 'Russian Federation',
    id: 'Russian Federation',
    inEuropeanUnion: false
  },
  {
    value: 'RW',
    name: 'Rwanda',
    id: 'Rwanda',
    inEuropeanUnion: false
  },
  {
    value: 'BL',
    name: 'Saint Barthélemy',
    id: 'Saint Barthélemy',
    inEuropeanUnion: false
  },
  {
    value: 'SH',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    id: 'Saint Helena, Ascension and Tristan da Cunha',
    inEuropeanUnion: false
  },
  {
    value: 'KN',
    name: 'Saint Kitts and Nevis',
    id: 'Saint Kitts and Nevis',
    inEuropeanUnion: false
  },
  {
    value: 'LC',
    name: 'Saint Lucia',
    id: 'Saint Lucia',
    inEuropeanUnion: false
  },
  {
    value: 'MF',
    name: 'Saint Martin (French part)',
    id: 'Saint Martin (French part)',
    inEuropeanUnion: false
  },
  {
    value: 'PM',
    name: 'Saint Pierre and Miquelon',
    id: 'Saint Pierre and Miquelon',
    inEuropeanUnion: false
  },
  {
    value: 'VC',
    name: 'Saint Vincent and the Grenadines',
    id: 'Saint Vincent and the Grenadines',
    inEuropeanUnion: false
  },
  {
    value: 'WS',
    name: 'Samoa',
    id: 'Samoa',
    inEuropeanUnion: false
  },
  {
    value: 'SM',
    name: 'San Marino',
    id: 'San Marino',
    inEuropeanUnion: false
  },
  {
    value: 'ST',
    name: 'Sao Tome and Principe',
    id: 'Sao Tome and Principe',
    inEuropeanUnion: false
  },
  {
    value: 'SA',
    name: 'Saudi Arabia',
    id: 'Saudi Arabia',
    inEuropeanUnion: false
  },
  {
    value: 'SN',
    name: 'Senegal',
    id: 'Senegal',
    inEuropeanUnion: false
  },
  {
    value: 'RS',
    name: 'Serbia',
    id: 'Serbia',
    inEuropeanUnion: false
  },
  {
    value: 'SC',
    name: 'Seychelles',
    id: 'Seychelles',
    inEuropeanUnion: false
  },
  {
    value: 'SL',
    name: 'Sierra Leone',
    id: 'Sierra Leone',
    inEuropeanUnion: false
  },
  {
    value: 'SG',
    name: 'Singapore',
    id: 'Singapore',
    inEuropeanUnion: false
  },
  {
    value: 'SX',
    name: 'Sint Maarten (Dutch part)',
    id: 'Sint Maarten (Dutch part)',
    inEuropeanUnion: false
  },
  {
    value: 'SK',
    name: 'Slovakia',
    id: 'Slovakia',
    inEuropeanUnion: true
  },
  {
    value: 'SI',
    name: 'Slovenia',
    id: 'Slovenia',
    inEuropeanUnion: true
  },
  {
    value: 'SB',
    name: 'Solomon Islands',
    id: 'Solomon Islands',
    inEuropeanUnion: false
  },
  {
    value: 'SO',
    name: 'Somalia',
    id: 'Somalia',
    inEuropeanUnion: false
  },
  {
    value: 'ZA',
    name: 'South Africa',
    id: 'South Africa',
    inEuropeanUnion: false
  },
  {
    value: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    id: 'South Georgia and the South Sandwich Islands',
    inEuropeanUnion: false
  },
  {
    value: 'SS',
    name: 'South Sudan',
    id: 'South Sudan',
    inEuropeanUnion: false
  },
  {
    value: 'ES',
    name: 'Spain',
    id: 'Spain',
    inEuropeanUnion: true
  },
  {
    value: 'LK',
    name: 'Sri Lanka',
    id: 'Sri Lanka',
    inEuropeanUnion: false
  },
  {
    value: 'SD',
    name: 'Sudan',
    id: 'Sudan',
    inEuropeanUnion: false
  },
  {
    value: 'SR',
    name: 'Suriname',
    id: 'Suriname',
    inEuropeanUnion: false
  },
  {
    value: 'SJ',
    name: 'Svalbard and Jan Mayen',
    id: 'Svalbard and Jan Mayen',
    inEuropeanUnion: false
  },
  {
    value: 'SZ',
    name: 'Swaziland',
    id: 'Swaziland',
    inEuropeanUnion: false
  },
  {
    value: 'SE',
    name: 'Sweden',
    id: 'Sweden',
    inEuropeanUnion: true
  },
  {
    value: 'CH',
    name: 'Switzerland',
    id: 'Switzerland',
    inEuropeanUnion: false
  },
  {
    value: 'SY',
    name: 'Syrian Arab Republic',
    id: 'Syrian Arab Republic',
    inEuropeanUnion: false
  },
  {
    value: 'TW',
    name: 'Taiwan, Province of China',
    id: 'Taiwan, Province of China',
    inEuropeanUnion: false
  },
  {
    value: 'TJ',
    name: 'Tajikistan',
    id: 'Tajikistan',
    inEuropeanUnion: false
  },
  {
    value: 'TZ',
    name: 'Tanzania, United Republic of',
    id: 'Tanzania, United Republic of',
    inEuropeanUnion: false
  },
  {
    value: 'TH',
    name: 'Thailand',
    id: 'Thailand',
    inEuropeanUnion: false
  },
  {
    value: 'TL',
    name: 'Timor-Leste',
    id: 'Timor-Leste',
    inEuropeanUnion: false
  },
  {
    value: 'TG',
    name: 'Togo',
    id: 'Togo',
    inEuropeanUnion: false
  },
  {
    value: 'TK',
    name: 'Tokelau',
    id: 'Tokelau',
    inEuropeanUnion: false
  },
  {
    value: 'TO',
    name: 'Tonga',
    id: 'Tonga',
    inEuropeanUnion: false
  },
  {
    value: 'TT',
    name: 'Trinidad and Tobago',
    id: 'Trinidad and Tobago',
    inEuropeanUnion: false
  },
  {
    value: 'TN',
    name: 'Tunisia',
    id: 'Tunisia',
    inEuropeanUnion: false
  },
  {
    value: 'TR',
    name: 'Turkey',
    id: 'Turkey',
    inEuropeanUnion: false
  },
  {
    value: 'TM',
    name: 'Turkmenistan',
    id: 'Turkmenistan',
    inEuropeanUnion: false
  },
  {
    value: 'TC',
    name: 'Turks and Caicos Islands',
    id: 'Turks and Caicos Islands',
    inEuropeanUnion: false
  },
  {
    value: 'TV',
    name: 'Tuvalu',
    id: 'Tuvalu',
    inEuropeanUnion: false
  },
  {
    value: 'UG',
    name: 'Uganda',
    id: 'Uganda',
    inEuropeanUnion: false
  },
  {
    value: 'UA',
    name: 'Ukraine',
    id: 'Ukraine',
    inEuropeanUnion: false
  },
  {
    value: 'AE',
    name: 'United Arab Emirates',
    id: 'United Arab Emirates',
    inEuropeanUnion: false
  },
  {
    value: 'GB',
    name: 'United Kingdom',
    id: 'United Kingdom',
    inEuropeanUnion: false
  },
  {
    value: 'US',
    name: 'United States',
    id: 'United States',
    inEuropeanUnion: false
  },
  {
    value: 'UM',
    name: 'United States Minor Outlying Islands',
    id: 'United States Minor Outlying Islands',
    inEuropeanUnion: false
  },
  {
    value: 'UY',
    name: 'Uruguay',
    id: 'Uruguay',
    inEuropeanUnion: false
  },
  {
    value: 'UZ',
    name: 'Uzbekistan',
    id: 'Uzbekistan',
    inEuropeanUnion: false
  },
  {
    value: 'VU',
    name: 'Vanuatu',
    id: 'Vanuatu',
    inEuropeanUnion: false
  },
  {
    value: 'VE',
    name: 'Venezuela, Bolivarian Republic of',
    id: 'Venezuela, Bolivarian Republic of',
    inEuropeanUnion: false
  },
  {
    value: 'VN',
    name: 'Viet Nam',
    id: 'Viet Nam',
    inEuropeanUnion: false
  },
  {
    value: 'VG',
    name: 'Virgin Islands, British',
    id: 'Virgin Islands, British',
    inEuropeanUnion: false
  },
  {
    value: 'VI',
    name: 'Virgin Islands, U.S.',
    id: 'Virgin Islands, U.S.',
    inEuropeanUnion: false
  },
  {
    value: 'WF',
    name: 'Wallis and Futuna',
    id: 'Wallis and Futuna',
    inEuropeanUnion: false
  },
  {
    value: 'EH',
    name: 'Western Sahara',
    id: 'Western Sahara',
    inEuropeanUnion: false
  },
  {
    value: 'YE',
    name: 'Yemen',
    id: 'Yemen',
    inEuropeanUnion: false
  },
  {
    value: 'ZM',
    name: 'Zambia',
    id: 'Zambia',
    inEuropeanUnion: false
  },
  {
    value: 'ZW',
    name: 'Zimbabwe',
    id: 'Zimbabwe',
    inEuropeanUnion: false
  }
];
